// Copyright 1999-2025. WebPros International GmbH. All rights reserved.

import locales from '../../locales';
const DEFAULT_LOCALE = 'en-US';
let currenLocale = DEFAULT_LOCALE;
export const setLocale = locale => {
  currenLocale = locale;
};
export const getLocale = () => currenLocale;
export const getLocaleMessages = () => (locales[currenLocale] ?? Object.values(locales).find(_ref => {
  let {
    language
  } = _ref;
  return language === `${currenLocale}`.toLocaleLowerCase();
}) ?? locales[DEFAULT_LOCALE])?.messages;